import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const FALCON_URL = 'https://api.falcon.finance/api/v1/statistics'
const sUSDf = 'Staked Falcon USD::sUSDf'

export const susdfFetcher: YieldFetcher = {
  label: 'SUSDF',
  fetch: async () => {
    const res = await fetch(FALCON_URL).then((r) => r.json())
    const apy = Number(res?.sUSDf_7d_apy ?? 0) * 100
    return { [sUSDf]: apyToAprPercent(apy) }
  },
}
